import { Suspense } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import SharedBusinessCard from 'src/features/business/components/shared-business-card'
import type { BusinessSummaryItem } from 'src/features/business/shared/schemas/business-item'
import { Button } from 'src/shared/components/ui/buttons/button'

import { useSharedBusinesses } from '../api/use-shared-business'
import SharedBusinessSectionSkeleton from '../skeletons/shared-business-section-skeleton'

const SharedBusinessSectionContent = ({ userId }: { userId: number }) => {
  const { data: sharedBusinessItems } = useSharedBusinesses(userId)
  const navigate = useNavigate()
  const sharedBusinesses =
    sharedBusinessItems
      ?.map((item) => item.business)
      .filter((business): business is BusinessSummaryItem => Boolean(business)) ?? []

  if (sharedBusinesses.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full flex-row items-center justify-between gap-4">
        <h1 className="text-[22px] font-semibold text-primary">Together on</h1>
        <Button variant="link" className="text-sm font-medium text-muted">
          View all
        </Button>
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
        {sharedBusinesses.map((business) => (
          <SharedBusinessCard
            key={business.id}
            name={[business.consumerFirstName, business.consumerLastName].filter(Boolean).join(' ')}
            desiredLocations={business.desiredLocations ?? []}
            exactLocations={business.exactLocations ?? []}
            mapSnapshot={business.mapSnapshot}
            onClick={() => {
              navigate(paths.business.getHref())
            }}
            teamMembers={business.teamMembers ?? []}
          />
        ))}
      </div>
    </div>
  )
}

const SharedBusinessSection = ({ userId }: { userId: number }) => {
  return (
    <Suspense fallback={<SharedBusinessSectionSkeleton />}>
      <SharedBusinessSectionContent userId={userId} />
    </Suspense>
  )
}

export default SharedBusinessSection
